<template>
  <div class="w100 pl20 pr20 pt20 pb20 bigbox" v-loading="loading">
    <div class="title">
        教职工花名册
    </div>

    <div class="table-con">
    <el-table :data="tableData" style="width: 100%" class="w100 mt20 table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          v-for="(item, index) in stafflist"
          :key="index + 'c'"
        >
        </el-table-column>
      </el-table>
    </div>

   <div class="mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination
          background
          @size-change="changeSize"
          @current-change="changePage"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>

  </div>
</template>

<script>
import { getStaffPage } from '@/api/management/staff';
export default {
  name: "staffRoster",
  data() {
    return {
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      stafflist: [
        {
          label: "工号",
          prop: "code",
          width: "80",
        },
        {
          label: "姓名",
          prop: "name",
          width: "80",
        },
        {
          label: "性别",
          prop: "gendervalue",
          width: "80",
        },
        {
          label: "出生日期",
          prop: "dateofbirth",
          width: "80",
        },
        {
          label: "身份证号码",
          prop: "credentialnumber",
          width: "100",
        },
        {
          label: "身份证住址",
          prop: "householdaddress",
          width: "100",
        },
        {
          label: "民族",
          prop: "nationvalue",
          width: "80",
        },
        {
          label: "籍贯",
          prop: "householdprovince2value",
          width: "80",
        },
        {
          label: "出生地",
          prop: "householdprovince1value",
          width: "80",
        },
        {
          label: "参加工作时间",
          prop: "startworktime",
          width: "120",
        },
        {
          label: "党派",
          prop: "politicalstatusvalue",
          width: "80",
        },
        {
          label: "岗位职务",
          prop: "post",
          width: "100",
        },
        {
          label: "行政级别",
          prop: "mainjobgradesvalue",
          width: "100",
        },
        {
          label: "任现职务时间",
          prop: "jointime",
          width: "120",
        },
        {
          label: "职称等级",
          prop: "jobtitlevalue",
          width: "100",
        },
        {
          label: "科室",
          prop: "deptName",
          width: "80",
        },
      ],
    };
  },
  mounted(){
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.loading = true;
      let params = {
        current: this.pageNum,
        size: this.pageSize,
      };
      const { data } = await getStaffPage(params);
      this.loading = false
      if (data.code == 0) {
        this.tableData = data.data.records;
        this.total = data.data.total;
      } else {
        this.$message.error(data.msg);
      }

    },
    // 条数
    changeSize(value) {
      this.pageSize = value;
      this.getTableData();
    },
    // 上下页
    changePage(value) {
      this.pageNum = value;
      this.getTableData();
    },
  },
};
</script>

<style scoped  lang="less">
.bigbox{
  height: 100%;
  display: flex;
  flex-direction: column;
  .title{
  padding: 0px 0px 20px 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.table-con{
  background-color: white;
  width: 100%;
  flex: 1;
}
}
  /deep/.el-table {
    width: 100%;
    .el-table__body-wrapper {
      max-height: calc(100vh - 300px);
      overflow-y: auto;

    }
  }
</style>
